var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
export class SubtopicQuestions {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get subtopic() {
        return this.parent;
    }
    get miniQuestions() {
        if (!this.subtopic.topic)
            return [];
        return this.subtopic.topic.topicMiniQuestions.miniQuestions.filter(q => q.subtopicName === this.subtopic.name);
    }
    get hiddenMiniQuestions() {
        if (!this.subtopic.topic)
            return [];
        return this.subtopic.topic.topicMiniQuestionsHidden.hiddenMiniQuestions.filter(q => q.subtopicName === this.subtopic.name);
    }
}
__decorate([
    cachedSet
], SubtopicQuestions.prototype, "miniQuestions", null);
__decorate([
    cachedSet
], SubtopicQuestions.prototype, "hiddenMiniQuestions", null);
